

import { Controller } from "@hotwired/stimulus";

export default class extends Controller {

  static targets = [];

  connect() {
    
  }

  completedForm(event) {
    event.preventDefault();

    this.element.dispatchEvent(new CustomEvent('extraDetailsComplete', {
      detail: { formName: 'driving-school-admin-booking-form-v2-extra-details',
      lessonDetails: {} }
    }));

  }


}